import { createSelector } from 'reselect';

const customerSelector = state => state.messageNotifiation;
const createMessageNotifySelector = createSelector(customerSelector, messageNotifiation => messageNotifiation);

export default createMessageNotifySelector;
